module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/126.4a2f2da7.svg";